import { RoleFieldsFragment } from 'src/types';

export class InvitationInput {
  constructor(
    public email: string,
    public roleIds: string[],
  ) {}
}

// Data structure for each invite row handling the email input, selected roles, and validation errors.
export class InviteRow {
  constructor(
    public email: string,
    public roles: RoleFieldsFragment[],
    public errors: { email: string; role: string },
  ) {}
}
